import { Outlet } from 'react-router-dom';
import { useDeepLinks } from '@/mobile/hooks/useDeepLinks';

/** Mounts native deep-link navigation inside the router tree. */
export function DeepLinkBridge() {
  useDeepLinks();
  return <Outlet />;
}
